// simple classnames-like utility method
// example utility, does not handle edge cases
export const classnames = (
  ...classes: (false | null | undefined | string | string[])[]
) => classes.flat().filter(Boolean).join(' ');
